/**
 * Componente Sections
 * Responsable de renderizar un grupo de tarjetas (tiles) bajo un título y un icono de sección.
 * * @param {string} title - Título de la sección (ej. "Aficionados").
 * @param {string} sectionIcon - Clase del icono de la sección (ej. "bi bi-people").
 * @param {Array} tiles - Lista de objetos con la info de cada tarjeta (id, name, icon, enabled, etc.).
 * @param {Function} onTileClick - Función que se ejecuta al hacer click en una tarjeta.
 * @param {number|string} activeId - ID del elemento que está actualmente activo para resaltar.
 */
const Sections = ({ title, sectionIcon, tiles, onTileClick, activeId }) => {

    // Si no hay tiles válidos para mostrar, mostramos el mensaje de fallback
    const hasVisibleTiles = tiles && tiles.some(tile => tile.visible);

    return (
        <div className='AdmDashboard__Container__Cards'>
            {/* Encabezado de la Sección */}
            <p className='AdmDashboard__Container__Cards__Title'><i className={sectionIcon}></i> {title}</p>

            <div className='AdmDashboard__Container__Cards__List'>
                {hasVisibleTiles ? (
                    tiles.map((tile, index) => {
                        // Solo renderizamos si la propiedad 'visible' es true
                        if (!tile.visible) return null;

                        // Determinamos si esta tarjeta específica está activa
                        const isActive = activeId === tile.id;

                        // Renderizado condicional: Habilitado vs Deshabilitado
                        return tile.enabled ? (
                            <div key={index} className={`AdmDashboard__Container__Cards__List__Card ${isActive ? 'AdmDashboard__Container__Cards__List__Card--Active' : ''}`} onClick={() => onTileClick(tile)}>
                                
                                {/* Renderizamos el icono específico de la tarjeta */}
                                <i className={`${tile.icon} AdmDashboard__Container__Cards__List__Card__Icon`}></i>
                                
                                <p className='AdmDashboard__Container__Cards__List__Card__Title'>{tile.name}</p>

                                {/* Indicador visual de activo */}
                                {isActive && (
                                    <p className='small text-center text-white'><i className="bi bi-check-circle-fill"></i> Activo</p>
                                )}
                            </div>
                        ) : (
                            // Estado Deshabilitado (Candado)
                            <div key={index} className='AdmDashboard__Container__Cards__List__Card AdmDashboard__Container__Cards__List__Card--Disabled'>
                                <i className="bi bi-lock-fill text-right"></i>
                                <i className={`${tile.icon} AdmDashboard__Container__Cards__List__Card__Icon`}></i>
                                {/* <i className="bi bi-lock text-center fs-2"></i> */}
                                <p className='AdmDashboard__Container__Cards__List__Card__Title'>{tile.name}</p>
                            </div>
                        );
                    })
                ) : (
                    // Mensaje por defecto si no hay elementos en esta sección
                    <p>Por el momento no tienes asignada alguna función en esta sección.</p>
                )}
            </div>
        </div>
    );
};

export { Sections };